module.exports = ($scope, $uibModalInstance, $http, $log, $analytics, Api) ->
  $scope.dismiss = ->
    $uibModalInstance.close 'OK'

